import { AxiosPromise } from 'axios';
import { post, get, content_types, convertToForm, deletee } from 'services';
import { IBrand } from 'types';

export type IaddBrandParams = {
  brand: string;
  brandLogo: File;
};
export const addBrandService = (
  params: IaddBrandParams
): AxiosPromise<IBrand> => {
  return post({
    subUrl: '/brands/create',
    data: convertToForm(params),
    headers: {
      ...content_types.multipart
    }
  });
};
export type IGetbrandRes = {
  data: {
    brands: IBrand[];
    total: number;
  };
};
export const getBrandsService = (): AxiosPromise<IGetbrandRes> => {
  return get({
    subUrl: '/brands/list',
    params: {
      limit: 0,
      offset: 0
    }
  });
};

export type IeditBrandParams = {
  id: string;
} & IaddBrandParams;
export const editBrandService = (
  params: IeditBrandParams
): AxiosPromise<IBrand[]> => {
  return post({
    subUrl: '/brands/update',
    data: convertToForm(params),
    headers: {
      ...content_types.multipart
    }
  });
};

export const deleteBrandService = (brandId: string): AxiosPromise<IBrand[]> => {
  return deletee({
    subUrl: '/brands/delete',
    params: { id: brandId }
  });
};
